export const VALIDATE_ENTERED_LICENSE_PLATES_START = 'VALIDATE_ENTERED_LICENSE_PLATES_START';
export const VALIDATE_ENTERED_LICENSE_PLATES_COMPLETED = 'VALIDATE_ENTERED_LICENSE_PLATES_COMPLETED';
export const VALIDATE_ENTERED_LICENSE_PLATES_ERROR = 'VALIDATE_ENTERED_LICENSE_PLATES_ERROR';
export const IMPORT_VALID_LICENSE_PLATES_START = 'IMPORT_VALID_LICENSE_PLATES_START';
export const IMPORT_VALID_LICENSE_PLATES_COMPLETED = 'IMPORT_VALID_LICENSE_PLATES_COMPLETED';
export const IMPORT_VALID_LICENSE_PLATES_ERROR = 'IMPORT_VALID_LICENSE_PLATES_ERROR';
export const RESET_IMPORT_STATE = 'RESET_IMPORT_STATE';

//------------------------------------------------------------------------

export const validateEnteredLicensePlates = (telematicAccountType, licensePlates) => {
    return {
        type: VALIDATE_ENTERED_LICENSE_PLATES_START,
        payload: { telematicAccountType, licensePlates }
    };
};

export const validateEnteredLicensePlatesCompleted = validationResult => {
    return {
        type: VALIDATE_ENTERED_LICENSE_PLATES_COMPLETED,
        payload: { validationResult }
    };
};

export const validateEnteredLicensePlatesError = error => {
    return {
        type: VALIDATE_ENTERED_LICENSE_PLATES_ERROR,
        error: error
    };
};

//------------------------------------------------------------------------

export const importValidLicensePlates = (telematicAccountType, proposedDbActions, fullyValid) => {
    return {
        type: IMPORT_VALID_LICENSE_PLATES_START,
        payload: { telematicAccountType, proposedDbActions, fullyValid }
    };
};

export const importValidLicensePlatesCompleted = () => {
    return {
        type: IMPORT_VALID_LICENSE_PLATES_COMPLETED,
        payload: {}
    };
};

export const importValidLicensePlatesError = error => {
    return {
        type: IMPORT_VALID_LICENSE_PLATES_ERROR,
        payload: {},
        error: error
    };
};

//------------------------------------------------------------------------

export const resetImportState = () => {
    return {
        type: RESET_IMPORT_STATE,
        payload: {}
    };
};
